import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import CachedDataService from '../../utilities/cached-data-service'
import USER_ROLES from '../../constants/user-roles'
import sortByName from './sort-by-name'

const cachedDataService = new CachedDataService({ stdTTL: 3600 })

const fetchData = (bypassCache) => {
    const url = urlGenerator.getUsers(0, 500, USER_ROLES.FACILITATOR)
    return cachedDataService.retrieveData(url, async () => axios.get(url, createRequestConfig())
        .then(property('data'))
        .then(data => data.items)
        .then(items => items.map(i => ({
            ...i,
            id: i.id,
            name: `${i.lastName}, ${i.firstName}`
        })))
        .then(sortByName)
    , bypassCache)
}

export default fetchData